import React from 'react';

/**
 * Sales Tools — Phase 3.2.
 * Lucide doesn't ship a WhatsApp glyph (trademark / branding), and
 * `MessageCircle` reads as a generic chat bubble. This is the
 * official-shape logo as a tiny inline SVG, sized to match Lucide
 * icons via the `size` prop, with `fill="currentColor"` so the
 * parent's `color` controls the tint.
 */
export default function WhatsAppIcon({ size = 16, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden
    >
      <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.88 11.9L4 20l4.2-1.1a7.93 7.93 0 0 0 3.85.98h.01a7.94 7.94 0 0 0 5.54-13.56zM12.06 18.5h-.01a6.59 6.59 0 0 1-3.36-.92l-.24-.14-2.49.65.66-2.43-.16-.25a6.6 6.6 0 1 1 5.6 3.09zm3.62-4.94c-.2-.1-1.18-.58-1.36-.65-.18-.07-.31-.1-.45.1-.13.2-.51.65-.62.78-.12.13-.23.15-.42.05-.2-.1-.84-.31-1.6-.99-.59-.53-.99-1.18-1.1-1.38-.12-.2-.01-.31.09-.4.09-.09.2-.23.3-.35.1-.12.13-.2.2-.33.06-.13.03-.25-.02-.35-.05-.1-.45-1.08-.62-1.48-.16-.39-.33-.34-.45-.34h-.39c-.13 0-.34.05-.52.25-.18.2-.69.67-.69 1.63 0 .96.7 1.89.8 2.02.1.13 1.38 2.1 3.34 2.95 1.96.85 1.96.57 2.32.53.36-.03 1.18-.48 1.34-.95.17-.46.17-.86.12-.94-.05-.08-.18-.13-.38-.23z" />
    </svg>
  );
}
